/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import Form from 'react-bootstrap/Form';
import { useDispatch, useSelector } from 'react-redux';
import {
  getCommonDropdownList,
  maintainContractActions,
} from '../store/actions';
import ViewHistoryComponent from '../../../../SharedModules/MicroFrontend/ViewHistoryComponent';

const Calc = ({ isEnablebyRole = true }) => {
  const dispatch = useDispatch();
  const maintainContractState = useSelector(
    (state) => state.sharedState.ContractReducer.maintainContractState
  );
  const calTab = useSelector(
    (state) => state.sharedState.ContractReducer.maintainContractState.calTab
  );

  const getAllContractData = useSelector(
    (state) => state.sharedState?.ContractReducer?.getAllContractData
  );
  const searchContractState = useSelector(
    (state) => state.sharedState?.ContractReducer?.searchContractState
  );
  const [commonDropdownList, setCommonDropdownList] = useState({});
  const [keyValue, setKeyValue] = useState([]);
  const [showViewHistory, setShowViewHistory] = useState(false);
  //Onload of the calc tab
  React.useEffect(() => {
    getCommonDropdownList({
      codeDomainList: ['CONTRACT_CALC_METHOD_CD'],
    }).then((res) => {
      setCommonDropdownList(res);
    });
  }, []);
  // handing on change text boxes event
  const onChangeDetailsField = (e, name) => {
    const data = {
      ...maintainContractState,
      showSaveButton: 'Yes',
      calTab: {
        ...calTab,
        [name]: e.target.value,
      },
    };
    dispatch(maintainContractActions(data));
  };
  // handing view History popup
  const handleViewHistory = () => {
    setShowViewHistory(true);
    setKeyValue({
      CONTRACT_SEQ_NUM:
        getAllContractData?.cdetailsHeaderAndCalcAndMfgAndDetailsTab
          ?.contractSeqNum,
    });
  };
  return (
    <div
      className='tBillPanel custom-check frr-other-calc'
      data-testid='Calc-component'
    >
      <div className='panel pb-0'>
        {searchContractState.contractType === 'onSelect' ? (
          <div className='float-right th-icon-group mt-2'>
            <OverlayTrigger
              placement='bottom'
              overlay={<Tooltip id='history-tooltip'>View History</Tooltip>}
            >
              <div
                className='th-icon ic-history'
                role='button'
                data-testid='history-button'
                onClick={() => {
                  handleViewHistory();
                }}
              >
                <span className='ic-title'> History </span>
              </div>
            </OverlayTrigger>
          </div>
        ) : null}
      </div>
      <Form>
        <div className='my-4'>
          <fieldset className='custom-fieldset custom-height'>
            <legend aria-hidden='true' className='d-none' />
            <Form.Group
              className='mb-3 ml-3 pl-1 pt-2 dif form-group'
              controlId='formBasicCheckbox'
            >
              <FormControlLabel
                control={<Checkbox color='primary' />}
                data-testid='cmstape-checkbox'
                id='cmstape-checkbox'
                label='Include NDCs on CMS Tape'
                disabled={isEnablebyRole === false}
                checked={calTab.cmsNdcInclInd}
                value={calTab.cmsNdcInclInd}
                onClick={() => {
                  if (isEnablebyRole !== false) {
                    const data = {
                      ...maintainContractState,
                      showSaveButton: 'Yes',
                      calTab: {
                        ...calTab,
                        cmsNdcInclInd: !calTab.cmsNdcInclInd,
                      },
                    };
                    dispatch(maintainContractActions(data));
                  }
                }}
              />
              <FormControlLabel
                control={<Checkbox color='primary' />}
                id='not-on-cmstape-checkbox'
                data-testid='not-on-cmstape-checkbox'
                label='Include NDCs not on the CMS Tape'
                className='ml-5'
                disabled={isEnablebyRole === false}
                checked={calTab.nonCmsNdcInclInd}
                value={calTab.nonCmsNdcInclInd}
                onClick={() => {
                  if (isEnablebyRole !== false) {
                    const data = {
                      ...maintainContractState,
                      showSaveButton: 'Yes',
                      calTab: {
                        ...calTab,
                        nonCmsNdcInclInd: !calTab.nonCmsNdcInclInd,
                      },
                    };
                    dispatch(maintainContractActions(data));
                  }
                }}
              />
            </Form.Group>
            <div className='form-wrapper db'>
              <div className='row'>
                <div className='col-12 col-sm-6 col-lg-4 col-xl-4'>
                  <div className='mui-custom-form input-md'>
                    <TextField
                      label='Contract Calculation Method Code'
                      id='contract-calculation-method-code'
                      data-testid='contract-calculation-method-code'
                      fullWidth
                      select
                      disabled={isEnablebyRole === false}
                      placeholder='Please Select One'
                      inputProps={{
                        maxLength: 10,
                        id: 'contract-calculation-method-code',
                      }}
                      InputLabelProps={{ shrink: true }}
                      value={
                        calTab?.contractCalcMethodCd
                          ? calTab.contractCalcMethodCd
                          : '-1'
                      }
                      onChange={(e) => {
                        onChangeDetailsField(e, 'contractCalcMethodCd');
                      }}
                    >
                      <MenuItem
                        key=''
                        value='-1'
                        className='frr-dropdown-blank-item'
                      />
                      {commonDropdownList &&commonDropdownList?.CONTRACT_CALC_METHOD_CD?.map(
                        (res, key) => (
                          <MenuItem
                            value={res?.codeValueID?.codeValue}
                            key={key}
                          >
                            {res.codeValueID?.codeValue} :{' '}
                            {res.shortDescription}
                          </MenuItem>
                        )
                      )}
                    </TextField>
                  </div>
                </div>
                {calTab.contractCalcMethodCd !== 'CMS' && (
                  <div className='col-12 col-sm-6 col-lg-4 col-xl-4'>
                    <div className='mui-custom-form input-md'>
                      <TextField
                        id='Percent-for-category-N'
                        label='Percent for category N'
                        data-testid='Percent-for-category-N'
                        fullWidth
                        placeholder=''
                        disabled={isEnablebyRole === false}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={
                          calTab?.calcNonInnovPct ? calTab.calcNonInnovPct : ''
                        }
                        inputProps={{
                          maxLength: 16,
                          id: 'Percent-for-category-N',
                        }}
                        onChange={(e) => {
                          if (e.target.value && e.target.value.includes('.')) {
                            const rx = /^[0-9]{0,9}(\.[0-9]{0,6})?$/;
                            if (rx.test(e.target.value)) {
                              onChangeDetailsField(e, 'calcNonInnovPct');
                            }
                          } else {
                            const rx_without = /^[0-9]{0,9}?$/;
                            if (rx_without.test(e.target.value)) {
                              onChangeDetailsField(e, 'calcNonInnovPct');
                            }
                          }
                        }}
                      />
                    </div>
                  </div>
                )}
                {calTab.contractCalcMethodCd !== 'CMS' && (
                  <div className='col-12 col-sm-6 col-lg-4 col-xl-4'>
                    <div className='mui-custom-form input-md'>
                      <TextField
                        id='Percent-for-category-S/I'
                        label='Percent for category S/I'
                        data-testid='Percent-for-category-S/I'
                        fullWidth
                        placeholder=''
                        disabled={isEnablebyRole === false}
                        InputLabelProps={{
                          shrink: true,
                        }}
                        value={
                          calTab?.calcInnovSinglePct
                            ? calTab.calcInnovSinglePct
                            : ''
                        }
                        inputProps={{
                          maxLength: 16,
                          id: 'Percent-for-category-S/I',
                        }}
                        onChange={(e) => {
                          if (e.target.value && e.target.value.includes('.')) {
                            const rx = /^[0-9]{0,9}(\.[0-9]{0,6})?$/;
                            if (rx.test(e.target.value)) {
                              onChangeDetailsField(e, 'calcInnovSinglePct');
                            }
                          } else {
                            const rx_without = /^[0-9]{0,9}?$/;
                            if (rx_without.test(e.target.value)) {
                              onChangeDetailsField(e, 'calcInnovSinglePct');
                            }
                          }
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
          </fieldset>
        </div>
      </Form>
      {showViewHistory && (
        <ViewHistoryComponent
          setShowViewHistory={setShowViewHistory}
          tableName='CONTRACT'
          keyValue={keyValue}
          columnNames='CMS_NDC_INCL_IND,NON_CMS_NDC_INCL_IND,CONTRACT_CALC_METHOD_CD,CALC_NON_INNOV_PCT,CALC_INNOV_SINGLE_PCT'
        />
      )}
    </div>
  );
};
export default Calc;
